const $ = require( 'jquery' );
import 'jquery-inview/jquery.inview';
import Headroom from 'headroom.js';

import {onLCP, onFID, onCLS} from 'web-vitals';



let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty( '--vh', `${ vh }px` );

window.addEventListener( 'resize load', () => {
  vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty( '--vh', `${ vh }px` );
} );

$( function() {
  fixFocus();
  initAccordion();
  initInviewAnimate();
  initHeadroom();
  mainMenu();
  jumpToSection();

  onCLS(console.log);
  onFID(console.log);
  onLCP(console.log);

} );

function fixFocus() {
   $('body').on('keydown', function(e) {
    var keyCode = e.key || e.code; 
    if (keyCode == 'Tab') {
      $('body').addClass('tab-pressed');
    } 
 });
}

function initHeadroom() {
  const headerElements = document.getElementsByClassName( 'site-header' ),
    headerElementsNo = headerElements.length;

  if ( headerElementsNo > 0 ) {
    for ( let i = 0; i < headerElementsNo; i++ ) {
      const headroom = new Headroom( headerElements[ i ] );
      headroom.init();
    }
  }
}

function initInviewAnimate() {
  const inviewElements = $( '.inview-animate--fade' )
    .add( '.inview-animate--move-up' )
    .add( '.inview-animate--move-down' )
    .add( '.inview-animate--move-left' )
    .add( '.inview-animate--move-right' )
    .add( '.inview-animate' )
    .add( '.inview-animate--scale' )
    .add( '.inview-animate--line' )
    .add( '.vertical-line' )

  inviewElements.each( function() {
    const thisInviewElement = $( this );

    thisInviewElement.bind( 'inview', function( event, visible ) {
      if ( visible === true ) {
        thisInviewElement.addClass( 'inview-active' );
      }
    } );
  } );
}

function mainMenu() {
  $('.facebook-menu-item a').html('<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"/></svg>').attr("aria-label", "facebook");
  $('.linkedin-menu-item a').html('<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"/></svg>').attr("aria-label", "linkedin");  
  $('.header-actions__open').on('click', function() {
    $('.site-header__nav').toggleClass('active');
  });
  if(window.innerWidth < 1170) {
    $('.site-header__nav .menu-item-has-children').prepend("<span><svg viewBox='0 0 320 512' xmlns='http://www.w3.org/2000/svg'><path d='M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z'></path></svg></span>");
    $('.site-header__nav .sub-menu').slideToggle();
    $('.site-header__nav .menu-item-has-children span').off('click').on('click', function (e) {
      $(this).parent().find('>.sub-menu').slideToggle();
    });
  }
}

function jumpToSection() {
  // Add smooth scrolling to all links

  $('a[href*="#"]:not([href="#"])').on('click', function(e) {
     
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top - 150
        }, 300, "linear"); 
        return false;
      }
    }
  });
}

function initAccordion() {

	$('.question').on('click', function(e) {
		$('.question').not($(this)).removeClass('open');
		$(this).toggleClass('open');
		var el = $(this).next('.answer');

		var vis = el.is(':visible');
		$('.answer').slideUp();
    if (vis) {
      el.slideUp();
    } else {
      el.slideDown();
    }
	});
  $('.item-0 .question').trigger('click');
 
}